import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const NotFound = () => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100%"
    >
      <Typography variant="h1">404</Typography>
      <Typography variant="h4">Page Not Found</Typography>
    </Stack>
  );
};

export default NotFound;
